export const navItems = [
    {
        title: "Home",
        path: "/",
        className: "home",
        active: true
    },
    {
        title: "Works",
        path: "/works",
        className: "works",
        active: false
    },
    {
        title: "Teams",
        path: "/teams",
        className: "teams",
        active: false
    },
    {
        title: "Contact",
        path: "/contactUs",
        className: "contact",
        active: false

    },
]